import Entity from 'utilities/Entity';

class User extends Entity {

}

export default new User();


// WEBPACK FOOTER //
// ./resources/assets/actions/user.js